// components/ContactSales.jsx
import React, { useState } from 'react';

export default function ContactSales() {
    const [formData, setFormData] = useState({ name: '', email: '', company: '', message: '' });
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle your form submission logic here
        setSubmitted(true);
    };

    return (
        <section className="py-20 md:py-28 bg-gray-50 min-h-screen flex items-center">
            <div className="max-w-4xl mx-auto px-6 lg:px-8 w-full">
                <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        Talk to Our Sales & Support Team
                    </h1>
                    <p className="text-xl text-gray-600">
                        Discover how Arxis Accounting can streamline your financial workflows and compliance.
                    </p>
                </div>

                <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100 max-w-2xl mx-auto">
                    {submitted ? (
                        <div className="text-center py-12">
                            <span className="text-5xl">🎉</span>
                            <h2 className="text-2xl font-bold text-gray-900 mt-4 mb-2">Thank You!</h2>
                            <p className="text-gray-600">Our team will reach out to you within 24 hours.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
                                <input
                                    type="text" required rows="4"
                                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                                <input
                                    type="email" required
                                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Company Name</label>
                                <input
                                    type="text" required
                                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">How can we help you?</label>
                                <textarea
                                    required rows="4"
                                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                className="w-full py-4 bg-[#4285F4] text-white font-semibold text-lg rounded-xl hover:bg-[#336bd1] transition shadow-md"
                            >
                                Submit Request
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </section>
    );
}